import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { IPlanGrade } from 'legacy/lut/classes/models/partner360/commitment/planGrade/planGrade'
import { IRawPlanGrade } from 'legacy/lut/classes/models/partner360/commitment/planGrade/rawPlanGrade'
import { selectCommitmentStatusesByProgramType } from 'legacy/lut/features/partner360/commitment'
import { createSelector } from 'reselect'

import { Nullable } from 'clickNgo/models/utils'

export const selectPlanGradeByProgramType = createSelector(
  [selectCommitmentStatusesByProgramType],
  (commitmentStatus): Nullable<IPlanGrade> => {
    const parsed = commitmentStatus ? parseJson<IRawPlanGrade>(commitmentStatus.PlanGrade) : null

    if (!parsed) {
      return null
    }
    return {
      PlanGrade: parsed.PlanGrade,
      PlanGradeMax: parsed.PlanGradeMax,
      Actions: parsed.Actions.map((action) => ({
        ...action,
        IsShowActionDetail: Boolean(action.IsShowActionDetail),
        ActionDetailParams: action.ActionDetailParams || null,
        ActionParams: action.ActionParams || null,
      })),
    }
  }
)
